export default __webpack_public_path__ + "static/media/hht1_home_img_EP10.25666ba8.png";